<template>
  <div>
    <el-select
      :multiple="multiple"
      :value="offer.discountConfig.couponId"
      allow-create
      placeholder="Select"
      @change="handleCouponSelect"
      :disabled="!coupons || disabled"
      filterable
      class="w-full"
    >
      <el-option-group v-for="group in couponsByType" :key="group.key" :label="group.label">
        <el-option v-for="item in group.options" :key="item.id" :label="item.name" :value="item.id">
          <div v-if="item.discountType === DISCOUNT_TYPE.PERCENT">
            <p class="float-left mr-4 text-gray-600 text-xs">{{ item.name }}</p>
            <p class="float-right text-brand-blue text-xs">
              {{ item.percentOff }}% off&nbsp;
              <span v-if="item.duration === 'repeating'">for {{ item.months }} {{ item.months === 1 ? 'month' : 'months' }}</span>
              <span v-else-if="item.duration === 'forever'">forever</span>
              <span v-else-if="item.duration === 'once'">once</span>
            </p>
          </div>
          <div v-else-if="item.discountType === DISCOUNT_TYPE.AMOUNT">
            <p class="float-left mr-4 text-gray-600 text-xs">{{ item.name }}</p>
            <p class="float-right text-brand-blue text-xs">
              {{ couponToString(item) }}
            </p>
          </div>
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
import { OFFER_TYPE, DISCOUNT_TYPE, couponToString } from '@/store/shared';

/* Component to select coupons, from EmailEditor.vue */
export default {
  name: 'CouponSelector',
  props: {
    offer: {
      type: Object,
      required: true,
    },
    coupons: {
      type: Array,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      OFFER_TYPE,
      DISCOUNT_TYPE,
      couponToString,
    };
  },
  computed: {
    couponsByType() {
      if (!this.coupons) {
        return [];
      }
      // prettier-ignore
      const groupOptions = [
        { key: `${DISCOUNT_TYPE.PERCENT}-once`, label: 'One-time Percentage Discount', options: [], discountType: DISCOUNT_TYPE.PERCENT },
        { key: `${DISCOUNT_TYPE.PERCENT}-repeating`, label: 'Multi-month Percentage Discount', options: [], discountType: DISCOUNT_TYPE.PERCENT },
        { key: `${DISCOUNT_TYPE.PERCENT}-forever`, label: 'Forever Percentage Discount', options: [], discountType: DISCOUNT_TYPE.PERCENT },
        { key: `${DISCOUNT_TYPE.AMOUNT}-once`, label: 'One-time Fixed Amount Discount', options: [], discountType: DISCOUNT_TYPE.AMOUNT },
        { key: `${DISCOUNT_TYPE.AMOUNT}-repeating`, label: 'Multi-month Fixed Amount Discount', options: [], discountType: DISCOUNT_TYPE.AMOUNT },
        { key: `${DISCOUNT_TYPE.AMOUNT}-forever`, label: 'Forever Fixed Amount Discount', options: [], discountType: DISCOUNT_TYPE.AMOUNT },
      ];
      this.coupons.forEach((coupon) => {
        const group = groupOptions.find((o) => o.key === `${coupon.discountType}-${coupon.duration}`);
        group.options.push(coupon);
      });
      const filteredOptions = groupOptions.filter((g) => g.options.length);
      filteredOptions.forEach((group) => {
        group.options.sort((a, b) => {
          if (group.discountType === DISCOUNT_TYPE.PERCENT) {
            if (a.percentOff === b.percentOff) {
              return a.months - b.months;
            }
            return a.percentOff - b.percentOff;
          }
          if (a.amountOff === b.amountOff) {
            return a.months - b.months;
          }
          return a.amountOff - b.amountOff;
        });
      });
      return filteredOptions;
    },
  },
  methods: {
    handleCouponSelect(couponId) {
      this.$emit('update', couponId);
    },
  },
};
</script>
